<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.9083 14.5078L13.1739 6.625H10.7677L11.0333 14.5078H12.9083Z" :fill="color" />
    <path
      d="M11.9708 18.125C12.351 18.125 12.657 18.013 12.8888 17.7891C13.1205 17.5651 13.2364 17.2812 13.2364 16.9375C13.2364 16.5885 13.1205 16.3021 12.8888 16.0781C12.657 15.8542 12.351 15.7422 11.9708 15.7422C11.5958 15.7422 11.2924 15.8555 11.0606 16.082C10.8289 16.3086 10.713 16.5938 10.713 16.9375C10.713 17.2812 10.8289 17.5651 11.0606 17.7891C11.2924 18.013 11.5958 18.125 11.9708 18.125Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM12 1.75C6.33908 1.75 1.75 6.33908 1.75 12C1.75 17.6609 6.33908 22.25 12 22.25C17.6609 22.25 22.25 17.6609 22.25 12C22.25 6.33908 17.6609 1.75 12 1.75Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'WarningOutlineIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
});
</script>
